export enum ToolbarButtonId {
    // Point Tool Buttons
    POINT_TOOL = 'point-tool',
    POINT_PICK = 'point-pick',
    ERASER_POINT = 'eraser-point',
    EYE_SHOW_POINT = 'eye-show-point',
    EYE_HIDE_POINT = 'eye-hide-point',
    REMOVE_ALL_POINT = 'remove-all-point',
    DONE_POINT = 'done-point',

    // Groups & General Elements
    DIM_GROUP = 'dim-group',
    POINT_GROUP = 'point-group',
    LABEL_PROPERTIES = 'label-properties',
    GROUP_DATA = 'group-data',
    DATA_ELEMENT = 'data-element',
    GROUP_CAMERA = 'group-camera',
    FLY_CAMERA = 'fly-camera',
    GROUP_NOTE = 'group-note',
    GROUP_DISTANCE = 'group-distance',
    ELEVATION_PROFILE = 'elevation-profile',

    // Clipping Plane Buttons
    CLIPPING_PLANE = 'clipping-plane',
    CLIPPING_PLANE_Z = 'clipping-plane-z',
    CLIPPING_PLANE_X = 'clipping-plane-x',
    CLIPPING_PLANE_Y = 'clipping-plane-y',
    CLIPPING_PLANE_TOGGLE_GIZMO = 'clipping-plane-toggle-gizmo',
    CLIPPING_PLANE_LOCK_GIZMO = 'clipping-plane-lock-gizmo',
    CLIPPING_PLANE_DELETE = 'clipping-plane-delete',
    CLIPPING_PLANE_DONE = 'clipping-plane-done',
}

/**
 * Utility function to generate unique ID with container ID suffix
 */
export const getToolbarId = (buttonId: ToolbarButtonId | string, containerId: string): string => {
    return `${buttonId}-${containerId}`;
};
